import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%', // Takes full width of the container
    backgroundColor: '#424242', // Dark background for the whole component
    color: '#fff',
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
  titleSection: {
    backgroundColor: '#333', // Even darker shade for the title section
    padding: '5px',
    paddingLeft: '20px',
    paddingTop: '10px', // Increased padding-top for a lower title
  },
  contentSection: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    position: 'relative', // Needed for absolute positioning of the icon button
  },
  text: {
    fontFamily: 'Monospace',
    fontSize: '0.75rem', // Smaller font size as per feedback
    flex: 1,
    overflow: 'hidden', // Hide overflow
    whiteSpace: 'nowrap', // Ensures text does not wrap
    marginRight: theme.spacing(6), // Reserve space for the copy icon
  },
  copyButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#fff',
  },
}));

const CopyClipboard = ({ textToCopy, title }) => {
  const classes = useStyles();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        setOpenSnackbar(true);
      })
      .catch(err => console.error('Could not copy text:', err));
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className={classes.container}>
      <div className={classes.titleSection}>
        <Typography variant="subtitle2">
          {title}
        </Typography>
      </div>
      <div className={classes.contentSection}>
        <div style={{ overflowX: 'auto' }}>
          <Typography variant="body2" className={classes.text}>
            {textToCopy}
          </Typography>
        </div>
        <Tooltip title="Copy to clipboard" placement="top">
          <IconButton onClick={copyToClipboard} className={classes.copyButton}>
            <FileCopyIcon />
          </IconButton>
        </Tooltip>
      </div>
      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="success" style={{ width: '100%' }}>
          {title} copied to clipboard!
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CopyClipboard;
